<script lang="ts">
    import type * as t from "~/types";
    import { cn } from "~/utils";
    import { getContext } from "./context";
    import ShopifyCdnImage from "~/components/ShopifyCdnImage.svelte";
    import clsx from "clsx";

    export let option: t.MultipleChoiceOption;
    export let imgObjectFit: t.MultipleChoiceStep["backgroundImageObjectFit"];

    let btnWidth: number | undefined;

    const ctx = getContext();
</script>

<button
    bind:clientWidth={btnWidth}
    on:click={() => {
        $ctx.selectOption(option);
    }}
    class={cn(
        "option flex size-full flex-col items-center rounded-2xl border border-transparent p-4 sm:rounded-3xl sm:px-8 sm:py-4",
    )}
    data-status={option === $ctx.selectedOption ? "selected" : "unselected"}
>
    <div class="w-full overflow-hidden">
        {#if option.backgroundImage}
            <ShopifyCdnImage
                image={option.backgroundImage}
                alt={`${option.title} image`}
                class={clsx(
                    "aspect-square size-full",
                    imgObjectFit === "cover" && "object-cover",
                    imgObjectFit === "contain" && "object-contain",
                    imgObjectFit === "fill" && "object-fill",
                )}
            />
        {/if}
    </div>
    <span
        class="text-[calc(14px + 0.3vw)] w-full flex-1 pt-2 text-left font-medium sm:pt-3"
        style="--btn-width: {btnWidth}px;"
    >
        {option.title}
    </span>
</button>

<style>
    button {
        box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.25);
    }

    button[data-status="selected"] {
        border: 2px solid transparent;
        background-image: linear-gradient(white, white),
            linear-gradient(
                45deg,
                var(--gradient-color1) 8.9%,
                var(--gradient-color2) 94.17%
            );
        background-origin: border-box;
        background-clip: padding-box, border-box;
    }

    @media (min-width: 640px) {
        button {
            box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
        }
    }
</style>
